import React, { useState } from 'react';
import { Box } from '@mui/material';

const CopyButton = ({ value, size = 13 }) => {
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText(String(value)).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        color: copied ? '#0AD69F' : '#C0C0C0',
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        transition: 'color 0.15s',
        '&:hover': { color: copied ? '#0AD69F' : '#027BC6' },
      }}
    >
      {copied ? (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      ) : (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
        </svg>
      )}
    </Box>
  );
};

export default CopyButton;
